module.exports = __webpack_public_path__ + "static/hospital-fachada-e8f422ed6568460d509fbd154e481b92.png";